<template>
  <section id="blog">
    <description>Erweitern Sie den Blog um Funktionen, die wir exakt nach Ihrem Design implementieren.</description>
    <section>
      <section>
        <Swiper :maxslides="3">
          <tile checkbox-id="kommentare" heading="Kommentare" input="checkbox" icon-id="comments" :contents="kommentareContent" :hints="kommentareHints" :input-disabled="disabledInputs" />
          <tile checkbox-id="share" heading="Sharing Buttons" input="checkbox" icon-id="sharing" :contents="shareContent" :hints="shareHints" :input-disabled="disabledInputs" />
          <tile checkbox-id="videoposts" heading="Video-Posts" input="checkbox" icon-id="video" :contents="videoContent" :hints="videoHints" :input-disabled="disabledInputs" />
        </Swiper>
      </section>
    </section>
    <controller :next="nextPageLink" />
    <tween-max v-if="false" />
    <inclusive-footer />
    <how-to />
    <made />
  </section>
</template>

<script>
import Description from '@/components/Description.vue'
import TweenMax from 'gsap/TweenMax'
import Swiper from '@/components/Swiper.vue'
import Tile from '@/components/Tile.vue'
import Controller from '@/components/Controller.vue'
import HowTo from '@/components/HowTo.vue'
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import Made from '@/components/Made.vue'
export default {
  name: 'blog',
  data: function () {
    return {
      kommentareContent: [
        { sentence: 'Nutzern die Möglichkeit geben, unter den Beiträgen zu kommentieren' },
        { sentence: 'Kommentare können moderiert oder gelöscht werden' }
      ],
      kommentareHints: [
        { sentence: 'Kommentare sind zu einzelnen Posts aktivierbar oder deaktivierbar bzw. können nach belieben geschlossen werden' },
        { sentence: 'Kommentare können wiederum kommentiert werden' }
      ],
      shareContent: [
        { sentence: 'Soziale Medien durch Teilen-Buttons einbeziehen' },
        { sentence: 'Nutzer motivieren, die Posts auf sozialen Medien zu teilen' }
      ],
      shareHints: [
        { sentence: 'Teilen-Buttons unter den einzelnen Posts und im Blog-Feed' }
      ],
      videoContent: [
        { sentence: 'Videos von Platformen wie YouTube oder Vimeo in Posts anzeigen und abspielen' }
      ],
      videoHints: [
        { sentence: 'Videos werden auf YouTube oder Vimeo hochgeladen und anschließend der Video-Link zum passenden Post hinzugefügt' },
        { sentence: 'User können die Videos ansehen, ohne die Website zu verlassen' }
      ]
    }
  },
  components: {
    Swiper,
    Tile,
    HowTo,
    Controller,
    TweenMax,
    InclusiveFooter,
    Description,
    Made
  },
  created: function () {
    if (!this.$root.items.find(item => item.id === 'blogfunktion').status) {
      this.$router.push('templates')
    }
  },
  computed: {
    disabledInputs: function () {
      return !this.$root.items.find(item => item.id === 'blogfunktion').status
    },
    nextPageLink: function () {
      if (this.$root.items.find(item => item.id === 'onlineshop').status) {
        return '/shop'
      } else {
        return '/technisches'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#blog {
  padding-top: 80px;
  #description {
    padding: 0 15px;
    p {
      font-size: 18px;
    }
  }
}
@media (min-height: 420px) {
  #blog {
    padding-bottom: 107px;
  }
}
@media (min-height: 520px) {
  #blog {
    padding-bottom: 127px;
  }
}
@media(min-width:767px) {
  #blog {
    padding-top: 100px;
    #description {
      padding: 0 40px;
      p {
        font-size: 20px;
      }
    }
  }
}
</style>
